import styled from '@emotion/styled'
import theme from '../../../styles/theme'
import { scrollbarStyle } from '../../../styles/Scrollbar.styles'

export const ComboBoxContainer = styled.div`
  position: relative;
  width: 100%;
`

export const ComboBoxToggle = styled.div<{
  isOpen: boolean
  disabled?: boolean
}>`
  background: ${theme.colors.surface};
  border: 1px solid ${theme.colors.backgroundDark};
  border-radius: 8px;
  padding: 8px 12px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:not(.disabled):hover {
    border-color: ${(props) =>
      props.isOpen
        ? theme.colors.secondHighlight
        : theme.colors.backgroundDark};
  }

  &.disabled {
    opacity: 0.5;
  }

  ${(props) =>
    props.isOpen &&
    `
    border-color: ${theme.colors.secondHighlight};
  `}
`

export const ComboBoxInput = styled.input`
  border: none;
  outline: none;
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
  background: transparent;
  width: 100%;
  padding: 0;
  margin: 0;
  height: auto;
  font-family: inherit;

  &::placeholder {
    color: #667085;
  }

  &:disabled {
    cursor: not-allowed;
  }
`

export const ComboBoxDisplay = styled.div`
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  color: #344054;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  min-height: 20px;

  padding: 0;
  margin: 0;
  height: auto;

  &.placeholder {
    color: #667085;
  }
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const ComboBoxMenu = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  min-width: 100%;
  width: max-content;
  max-width: min(36rem, calc(100vw - 2rem));
  margin-top: 2px;
  border: 1px solid ${theme.colors.backgroundDark};
  border-radius: 8px;
  box-shadow: ${theme.shadows.light};
  max-height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
  ${scrollbarStyle}
  z-index: 1000;
  background-color: ${theme.colors.surface};
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
`

export const ComboBoxMenuItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  color: #344054;
  font-size: 14px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;

  &:hover {
    background-color: ${theme.colors.secondLight};
  }

  &.selected {
    background-color: ${theme.colors.second};
  }

  &.no-results {
    cursor: default;
    color: #667085;
    font-style: italic;

    &:hover {
      background-color: transparent;
    }
  }
`

export const ItemIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
`
